import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { FreeMode, Autoplay } from "swiper";
import abhik from '../../../img/Abhik.jpeg';
import Menus from '../../../img/Menus.jpeg';
import Chahat from '../../../img/Chahat.jpeg';
import Piyus from '../../../img/PiyushGoyal.jpeg';
import Arfaa from '../../../img/Arfaa.jpeg';
import Shivani from '../../../img/ShivaniSaluja.png';
import Muskan from '../../../img/Dr.Muskan.png';
import Stuti from '../../../img/StutiAjmera.jpeg';
import Nikita from '../../../img/NikitaYadav.jpeg';

const Testimonial = () => {
    const blogs = [
        { title1: "I'm counselor of filo. It is really a good platform for guiding all students. I request you to share this app in rural areas students also. This maybe very helpful for them to clear their career related doubts.", name: 'Menus Garg' },
        { title1: "This is very  good platform for a counselor to earn online. I'm very happy with this. Thank you", name: 'Dr. Chahat', image: Chahat },
        { title1: "Career Hikers is a very good platform of guiding  and helping students. It gives an opportunity to work freely without any target oriented boundations. I like using it as it is easy to use and also solutions can be directly explain to the students. In this payment is also done timely.", name: 'Arfaa' },
        { title1: 'This app is a very good platform for the students who wants to clear their career related doubts. As a counselor my experience is very nice and the best thing is that we can work as per our convience.', name: 'Shivani Saluja', },
        { title1: 'This is really a very good initiative by Career Hikers team. As a counselor it is very much convenient and comfortable to work with. And morover there is no any fixed timing of work, u can work any time and any number of hours. and the payments are done regularly and theres no any problem in payment. And even for students its really good platform to clear their doubts and queries regarding their career.', name: 'Dr. Muskan (PT)' },
        { title1: 'It is a good platform for both a counselor and a student, it help a lot for unemployed counselor at this pandemic condition. I recommended it for both students as well as counselor to come and join this online platform. I really love Career Hikers for its amazing services for counselors as well as students.', name: 'Stuti Ajmera' },
        { title1: "Easy way to connect the counselors for students who really want to clear their doubts. It also gives the opportunity to the students to choose their favourite Career. It is really a good platform for both counselors and students.", name: 'Arvind Singh' },
        { title1: "It is good platform for being professional along with housewife. Thanks a lot Career Hikers team to create this platform!!", name: 'Priti Chauhan' }

    ];

    return (
        <div className='pb-10 md:mt-4 mt-8'>
            <h1 className='text-2xl md:text-5xl font-bold text-center text-sky-900'>Mentors Testimonials</h1>
            <div className=" my-10 ">
                <Swiper
                    breakpoints={{
                        // when window width is >= 640px
                        640: {
                            width: 640,
                            slidesPerView: 1,
                        },
                        // when window width is >= 768px
                        768: {
                            width: 768,
                            slidesPerView: 3,
                        },
                        1024: {
                            width: 1024,
                            slidesPerView: 3,
                        },
                    }}
                    slidesPerView={1}
                    spaceBetween={10}
                    freeMode={true}
                    pagination={{
                        clickable: true,
                    }}
                    autoplay={{ delay: 3000 }}
                    modules={[FreeMode, Autoplay]}
                    className=""
                >
                    {
                        blogs?.map((blog, i) => <SwiperSlide key={i} className='p-4 cursor-pointer'>
                            <div className="mt-3">
                                <p className="text-2xl font-semibold text-center">{blog?.name}</p>
                                <h4 className="text-sm font-semibold text-center mt-4">{blog?.title1}</h4>
                            </div>
                        </SwiperSlide>)
                    }
                </Swiper>
            </div>
        </div>
    );
};

export default Testimonial;